import React from 'react'
import { Heading, Text, Link, VStack } from '@chakra-ui/layout'
import { PageWrapper } from 'components/PageWrapper'
import { Container } from 'components/Container'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import NextLink from 'next/link'
import {getRoute} from 'utils/helpers'
import colors from 'theme/foundations/colors'


const platformName = process.env.NEXT_PUBLIC_APP_NAME
const contactEmail = process.env.NEXT_PUBLIC_CONTACT_EMAIL

const Contact = () => {
  const { t } = useTranslation('common')

  return (
    <PageWrapper title={t('contactPage.pageTitle')}>
      <Container>
        <VStack
          sx={{
            'h1,h2': { marginTop: '2rem !important' },
            maxWidth: '30rem',
            margin: '0 auto',
          }}
        >
          <Heading as="h1" size="2xl">
            {t('contactPage.pageTitle')}
          </Heading>
          <Text>
            {t('contactPage.paragraph1')}
          </Text>
          <Text>
            <b><code>{contactEmail}</code></b>
          </Text>
          <Text mt="4">
            <Trans
              i18nKey="common:contactPage.paragraph2"
              components={[<Link key="linktocommunity" as={NextLink} href={getRoute('community')} fontWeight="bold" textColor={colors.primary[300]} />]}
            />
          </Text>
          <Text>
            {t('contactPage.paragraph3')}
          </Text>
          <Text>
            {t('contactPage.paragraph4', { platformName })}
          </Text>
          <Text>
            {t('contactPage.paragraph5', { platformName })}
          </Text>
        </VStack>
      </Container>
    </PageWrapper>
  )
}

export default Contact
